import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Breadcrumb,
} from "react-bootstrap";

import {
  FiHome,
  FiDownload,
  FiChevronsUp,
} from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";

export default function Payslip() {
  const isMobile = window.innerWidth <= 768;

  const handleDownload = () => {
    window.print();
  };

  const earnings = [
    ["Basic Salary", "$3000"],
    ["House Rent Allowance (H.R.A.)", "$1000"],
    ["Conveyance", "$200"],
    ["Other Allowance", "$100"],
    ["Total Earnings", "$4300"],
  ];

  const deductions = [
    ["Tax Deducted at Source (T.D.S.)", "$200"],
    ["Provident Fund", "$300"],
    ["ESI", "$150"],
    ["Loan", "$50"],
    ["Total Earnings", "$700"],
  ];

  return (
    <div
      style={{
        background: "#f4f6f9",
        minHeight: "100vh",
        padding: isMobile ? "14px" : "24px",
      }}
    >
      <Container fluid>
        {/* TOP */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: isMobile ? "flex-start" : "center",
            flexDirection: isMobile ? "column" : "row",
            gap: "15px",
            marginBottom: "18px",
          }}
        >
          {/* LEFT */}
          {/* <div>
            <h2
              style={{
                fontSize: isMobile ? "34px" : "45px",
                fontWeight: "700",
                color: "#112b5c",
                marginBottom: "6px",
                lineHeight: 1.1,
              }}
            >
          
            </h2>

            <Breadcrumb
              style={{
                margin: 0,
                fontSize: "15px",
              }}
            >
              <Breadcrumb.Item href="#">
                <FiHome
                  style={{
                    fontSize: "15px",
                    marginTop: "-2px",
                  }}
                />
              </Breadcrumb.Item>

              <Breadcrumb.Item active>
                Payroll
              </Breadcrumb.Item>

              <Breadcrumb.Item active>
                Payslip
              </Breadcrumb.Item>
            </Breadcrumb>
          </div> */}
 <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>    Payslip</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
Payroll
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">    Payslip</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
          {/* RIGHT */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              width: isMobile ? "100%" : "auto",
            }}
          >
            {/* DOWNLOAD */}
            <button
              onClick={handleDownload}
              style={{
                background: "#0f172a",
                color: "#fff",
                border: "none",
                borderRadius: "7px",
                padding: "0 20px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                width: isMobile ? "100%" : "auto",
              }}
            >
              <FiDownload size={17} />
              Download
            </button>

            {/* COLLAPSE
            <button
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "7px",
                border: "1px solid #e5e7eb",
                background: "#fff",
                cursor: "pointer",
                flexShrink: 0,
              }}
            >
              <FiChevronsUp size={18} />
            </button> */}
          </div>
        </div>

        {/* CARD */}
        <Card
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "6px",
            overflow: "hidden",
            boxShadow: "none",
          }}
        >
          <Card.Body
            style={{
              padding: isMobile ? "18px" : "24px",
              background: "#fff",
            }}
          >
            {/* HEADER */}
            <Row
              style={{
                borderBottom: "1px solid #e5e7eb",
                paddingBottom: "22px",
                marginBottom: "24px",
                alignItems: "center",
              }}
            >
              {/* LOGO */}
              <Col md={6}>
                <div
                  style={{
                    marginBottom: isMobile
                      ? "18px"
                      : "0",
                  }}
                >
                  <img
                    src="/assets/img/logo-1.svg"
                    alt=""
                    style={{
                      width: "130px",
                      marginBottom: "12px",
                    }}
                  />

                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#64748b",
                      fontWeight: "400",
                    }}
                  >
                    3099 Kennedy Court Framingham,
                    MA 01702
                  </p>
                </div>
              </Col>

              {/* PAYSLIP INFO */}
              <Col
                md={6}
                style={{
                  textAlign: isMobile
                    ? "left"
                    : "right",
                }}
              >
                <h5
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#64748b",
                    marginBottom: "6px",
                  }}
                >
                  Payslip No
                  <span
                    style={{
                      color: "#f97316",
                    }}
                  >
                    {" "}
                    #PS4283
                  </span>
                </h5>

                <p
                  style={{
                    margin: 0,
                    fontSize: "16px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Salary Month :
                  <span
                    style={{
                      color: "#111827",
                      fontWeight: "500",
                    }}
                  >
                    {" "}
                    October 2024
                  </span>
                </p>
              </Col>
            </Row>

            {/* FROM TO */}
            <Row
              style={{
                borderBottom: "1px solid #e5e7eb",
                paddingBottom: "22px",
                marginBottom: "24px",
              }}
            >
              {/* FROM */}
              <Col md={5}>
                <div
                  style={{
                    marginBottom: isMobile
                      ? "22px"
                      : "0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#111827",
                      marginBottom: "12px",
                    }}
                  >
                    From
                  </p>

                  <h3
                    style={{
                      fontSize: isMobile
                        ? "20px"
                        : "18px",
                      fontWeight: "700",
                      color: "#112b5c",
                      marginBottom: "8px",
                    }}
                  >
                    XYZ Technologies
                  </h3>

                  <p
                    style={{
                      fontSize: "16px",
                      color: "#64748b",
                      marginBottom: "8px",
                    }}
                  >
                    2077 Chicago Avenue Orosi,
                    CA 93647
                  </p>

                  <p
                    style={{
                      fontSize: "16px",
                      color: "#64748b",
                      marginBottom: "8px",
                    }}
                  >
                    Email :
                    <span
                      style={{
                        color: "#111827",
                      }}
                    >
                      {" "}
                      [email protected]
                    </span>
                  </p>

                  <p
                    style={{
                      fontSize: "16px",
                      color: "#64748b",
                      marginBottom: 0,
                    }}
                  >
                    Phone :
                    <span
                      style={{
                        color: "#111827",
                      }}
                    >
                      {" "}
                      +1 987 654 3210
                    </span>
                  </p>
                </div>
              </Col>

              {/* TO */}
              <Col md={5}>
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#111827",
                      marginBottom: "12px",
                    }}
                  >
                    To
                  </p>

                  <h3
                    style={{
                      fontSize: isMobile
                        ? "20px"
                        : "18px",
                      fontWeight: "700",
                      color: "#112b5c",
                      marginBottom: "8px",
                    }}
                  >
                    Anthony Lewis
                  </h3>

                  <p
                    style={{
                      fontSize: "16px",
                      color: "#64748b",
                      marginBottom: "8px",
                    }}
                  >
                    Web Designer
                  </p>

                  <p
                    style={{
                      fontSize: "16px",
                      color: "#64748b",
                      marginBottom: "8px",
                    }}
                  >
                    Email :
                    <span
                      style={{
                        color: "#111827",
                      }}
                    >
                      {" "}
                      [email protected]
                    </span>
                  </p>

                  <p
                    style={{
                      fontSize: "16px",
                      color: "#64748b",
                      marginBottom: 0,
                    }}
                  >
                    Phone :
                    <span
                      style={{
                        color: "#111827",
                      }}
                    >
                      {" "}
                      +1 458 268 4738
                    </span>
                  </p>
                </div>
              </Col>
            </Row>

            {/* TITLE */}
            <h4
              style={{
                textAlign: "center",
                fontSize: isMobile
                  ? "21px"
                  : "17px",
                fontWeight: "700",
                color: "#112b5c",
                marginBottom: "28px",
              }}
            >
              Payslip for the moth of October
              2024
            </h4>

            {/* TABLES */}
            <Row>
              {/* EARNINGS */}
              <Col lg={6}>
                <div
                  style={{
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    overflow: "hidden",
                    marginBottom: isMobile
                      ? "20px"
                      : "0",
                  }}
                >
                  <div
                    style={{
                      background: "#f8fafc",
                      padding: "16px 20px",
                      borderBottom:
                        "1px solid #e5e7eb",
                      fontWeight: "700",
                      fontSize: "16px",
                      color: "#112b5c",
                    }}
                  >
                    Earnings
                  </div>

                  {earnings.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent:
                          "space-between",
                        padding: "15px 20px",
                        borderBottom:
                          i !== earnings.length - 1
                            ? "1px solid #e5e7eb"
                            : "none",
                        gap: "10px",
                      }}
                    >
                      <span
                        style={{
                          color: "#64748b",
                          fontSize: "16px",
                        }}
                      >
                        {item[0]}
                      </span>

                      <strong
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#111827",
                        }}
                      >
                        {item[1]}
                      </strong>
                    </div>
                  ))}
                </div>
              </Col>

              {/* DEDUCTIONS */}
              <Col lg={6}>
                <div
                  style={{
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      background: "#f8fafc",
                      padding: "16px 20px",
                      borderBottom:
                        "1px solid #e5e7eb",
                      fontWeight: "700",
                      fontSize: "16px",
                      color: "#112b5c",
                    }}
                  >
                    Deductions
                  </div>

                  {deductions.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent:
                          "space-between",
                        padding: "15px 20px",
                        borderBottom:
                          i !==
                          deductions.length - 1
                            ? "1px solid #e5e7eb"
                            : "none",
                        gap: "10px",
                      }}
                    >
                      <span
                        style={{
                          color: "#64748b",
                          fontSize: "16px",
                        }}
                      >
                        {item[0]}
                      </span>

                      <strong
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#111827",
                        }}
                      >
                        {item[1]}
                      </strong>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>

            {/* NET */}
            <div
              style={{
                marginTop: "22px",
                fontSize: "16px",
                color: "#64748b",
              }}
            >
              Net Salary :
              <span
                style={{
                  color: "#111827",
                  fontWeight: "500",
                }}
              >
                {" "}
                $3600(Three thousand six
                hundred only)
              </span>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}